import { render, staticRenderFns } from "./AgeCheckModal.vue?vue&type=template&id=ec46ccce"
import script from "./AgeCheckModal.vue?vue&type=script&lang=js"
export * from "./AgeCheckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec46ccce')) {
      api.createRecord('ec46ccce', component.options)
    } else {
      api.reload('ec46ccce', component.options)
    }
    module.hot.accept("./AgeCheckModal.vue?vue&type=template&id=ec46ccce", function () {
      api.rerender('ec46ccce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AgeCheckModal.vue"
export default component.exports